import './ProductDetail.css';

/**
 * @typedef {import('../model/ProductDetailModel').ProductDetailModel} ProductDetailModel
 */

/**
 * @param {{productDetails: ProductDetailModel[], pageTitle: string}} props
 */
const ProductDetail = ({ productDetails, pageTitle }) => {
    return (
        <div className="container-products-detail">
            <div className="image half-left">
                <img src="https://boac-website.s3.eu-central-1.amazonaws.com/icecream_product_message.png" alt="Left" />
            </div>
            <div className="ice-content">
                <h1>{pageTitle}</h1>

                {productDetails.map(item => (
                    <div key={item.id} className="imgholder">
                        <div className='img-holder-pic'><img src={item.image} alt={item.name} /></div>
                        <div className='img-holder-text'>
                            <ul>
                                <li><h3>{item.name}</h3></li>
                                <li><p>{item.detail}</p></li>
                                <li><button>{item.price}₺</button></li>
                            </ul>

                        </div>
                    </div>
                ))}
            </div>
            <div className="image half-right">
                <img src="https://boac-website.s3.eu-central-1.amazonaws.com/icecream_product_message.png" alt="Left" />
            </div>
        </div>
    );
}

export default ProductDetail;
